import { faCheckCircle } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

const Container = styled(Box)(({ theme }) => ({
    marginLeft: '2rem',
    marginRight: '2rem',
    [theme.breakpoints.down('sm')]: { marginLeft: 0, marginRight: 0 },
}));

const Item = styled(Box)(() => ({ display: 'flex' }));
const Icon = styled(Box)(({ theme }) => ({
    color: theme.palette.primary.light,
    marginRight: '1rem',
    fontSize: '1rem',
}));
const Text = styled(Typography)(({ theme }) => ({ paddingBottom: theme.spacing(1.5) }));

export interface EConsentChecklistProps {
    items: ReactNode[];
}

const EConsentChecklist: FC<EConsentChecklistProps> = ({ items }) => (
    <Container>
        {items.map((item, index) => (
            <Item key={index}>
                <Icon><FontAwesomeIcon fixedWidth icon={faCheckCircle} /></Icon>
                <Text>{item}</Text>
            </Item>
        ))}
    </Container>
);

export default EConsentChecklist;
